
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import FormInput from "@/components/agent-upload/FormInput";
import { AgentFormData } from "@/models/agent-form";

const VersionLicenseSection: React.FC = () => {
  const form = useFormContext<AgentFormData>();
  
  return (
    <div>
      <FormField
        control={form.control}
        name="version"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Version</FormLabel>
            <FormControl>
              <FormInput
                id="version"
                name="version"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="e.g., 1.0.0"
                error={form.formState.errors.version?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default VersionLicenseSection;
